import { html, LitEntity } from '../../utility/lit-entity';
import './fmm-integration-modal';
import { IntegrationOverviewMixin } from './integration-overview-mixin';

class FmmIntegrationOverview extends IntegrationOverviewMixin(LitEntity) {
  render() {
    return this.renderOverview();
  }

  renderModal() {
    return html`
      <fmm-integration-modal
        title="${this.title}"
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></fmm-integration-modal>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.integrationEnabled = this.entity.properties.secretUrl;
  }
}

window.customElements.define('fmm-integration-overview', FmmIntegrationOverview);
